  <div class="row mt-3 pt-2" *ngIf="finished">
    <div class="col-12 overflow-hidden pb-2">
      <span class="cursor-pointer" (click)="redirectToDetail()">
        <img src="assets/themes/icons/back-arrow.svg" alt="back-icon" width="15px" />
        {{mls.languageText.community.key28}}
      </span>
    </div>
  </div>

  <div *ngIf="errorMessage === '' && finished"
    infinitescroll=""
    class="row community-detail-container mb-4" ng-reflect-infinite-scroll-distance="5"
      ng-reflect-infinite-scroll-throttle="1000" ng-reflect-scroll-window="true">
      <div class="col-md-12 col-lg-8 pr-md-0">

          <div class="form-group col-12 px-0" *ngIf="isMembersSelectionOpen">
            <app-community-member-list *ngIf="isMembersSelectionOpen" [isCheckBoxModalOpen]="isMembersSelectionOpen"
              [popupLabel]="membersPopupLabel" [selectedListLength]="selectedMembers.length"
              [selectedLimit]="membersSelectedLimit" [completeSelectionLabel]="membersSelectionLabel"
              [isButtonDisable]="true" (emitCloseClicked)="closeMembersPopup()"
              [callingFrom]="callingFrom"
              [communityId]="communityDetailId"
              [showMobileBackButton]="showMobileBackButtonFlag"
              (onOriginalBack)="emitOriginalBack($event)"
              (memberSelected)=memberSelected($event)
              [existingCount]="memberCount"
              (emitSelectedarray)="addMember($event)"
              (emitCancelClicked)="resetCount()">
            </app-community-member-list>
          </div>
        <div class="bg-white rounded-corners-12 mb-2 clearfix">

            <div class="channel-header">
                <div class="channel-image-header overflow-hidden"></div>
                <div class="channel-heading p-4 clearfix position-relative d-md-flex align-items-center container-shadow" [id]="'COMMUNITY-DETAIL-' + communityDetail?.da_id">
                    <div class="community-detail-box-container align-self-start">
                        <div class="mr-2">
                          <img class="user-100"
                            class="rounded-corners-12"
                            [src]="communityDetail?.media_list[0]?.media_url"
                            onError="this.src='assets/themes/icons/banner-placeholder.svg';" />
                        </div>
                    </div>
                    <div class="px-md-2 py-md-0 py-2 flex-fill align-self-start">
                      <div class="py-1">
                          <p class="heading-3 mb-2" [id]="'COMMUNITY-DETAIL-TITLE-' + communityDetail?.da_id">{{communityDetail?.title}}</p>
                          <p class="mt-2" [id]="'COMMUNITY-DETAIL-CREATED-BY-' + communityDetail?.da_id">
                            <img
                                class="mr-1 channel-img channel-pic rounded-circle"
                                [src]="communityDetail?.created_by?.profile_pic"
                                onError="this.src='assets/themes/icons/user-profile-placeholder.svg';">
                                <span class="paragraph mx-2"><span class="color-grey-500">{{translations?.key1}}</span></span> <span class="paragraph-bold"><span class="color-grey-700">{{communityDetail?.created_by?.full_name}}</span></span></p>
                          <p *ngIf="communityDetail?.flags?.is_past_community !== isCreator && communityDetail?.flags?.is_active !== 0"
                          class="paragraph mt-2 member-count-container mb-3">
                            <img class="members-icon"
                              src="assets/themes/icons/community-member-icon.svg"
                              alt="Member icon" />
                            <span class="color-grey-500 ml-2">{{communityDetail?.members?.count}} {{communityDetail?.members?.text}}</span>
                            <ng-container *ngIf="communityDetail.member_type === memberType.ADMIN">
                              <span (click)="openMembersPopup()"
                                class="paragraph mx-2 cursor-pointer">{{membersPopupLabel}}
                              </span>
                              <p>
                                <span class="mx-2 chip small outline filled h-auto">
                                  {{mls.languageText.community.key95}}
                                </span>
                              </p>
                            </ng-container>
                          </p>
                          <p *ngIf="communityDetail?.flags?.is_active === numbers.ZERO"
                            class="paragraph mt-2 member-count-container mb-3">
                            <img class="members-icon" src="assets/themes/icons/community-member-icon.svg"
                            alt="Member icon" />
                            <span class="color-grey-500">{{communityDetail?.members?.count}} {{communityDetail?.members?.text}}</span></p>
                          <p *ngIf="communityDetail?.flags?.is_past_community === isCreator" class="paragraph mt-2">
                            <span class="color-grey-500">{{mls.languageText.community.key57}}</span></p>
                          <p *ngIf="communityDetail?.flags?.is_active === 0"
                            class="paragraph mt-2"><span class="color-grey-500">{{mls.languageText.community.key84}}</span></p>
                          <div
                            class="pt-3 pt-md-3 d-sm-flex flex-fill align-items-center justify-content-between">
                            <div class="align-items-center d-flex cta-container alignment">
                         
                              <button [disabled]="isPostButtonDisable" *ngIf="((communityDetail?.flags?.is_past_community !== isCreator) && !isJoinActionEnabled && !isRequestJoinActionEnabled && communityDetail?.flags?.is_active === isCommunityActive  && ((this.communityDetail?.action == null && this.communityDetail?.action?.length != 0) || contentPost == COMMUNITY_POST_CONSTANT.CONTENT_POST)) && (mls.featureOnOffList.moduleList.POST.value || !mls.userLoginFlow)"
                                class="btn-design medium filled"
                                (click)="showPostModal()">
                                {{translations.key8}}
                              </button>
                              <button
                                *ngIf="isJoinActionEnabled || isRequestJoinActionEnabled"
                                type="button"
                                class="btn-design medium outline mx-md-2"
                                [disabled]="communityDetail?.flags?.is_active !== isCommunityActive"
                                [class]="this.withdrawRequest || this.communityDetail?.request?.response === numbers.TWO ? 'outline' : (communityDetail?.flags?.is_active !== isCommunityActive ? 'outline-disabled disabled':'outline')"
                                (click)="joinCommunity()" [id]="'COMMUNITY-DETAIL-JOIN-BUTTON-' + communityDetail?.da_id">
                                <img src="assets/themes/icons/primary-loader.gif"
                                  width="20"
                                  height="20"
                                  class="cursor-pointer"
                                  *ngIf="loader"
                                  alt="loader"/>
                                <span *ngIf="!loader">{{translationText(true)}}</span>
                              </button>
                              <button class="btn-design medium outline ml-sm-2"
                                *ngIf="communityDetail?.privacy === privacy.PUBLIC && communityDetail?.flags?.is_active !== numbers.ZERO && communityDetail.flags.is_past_community !== isPast && (this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow)"
                                (click)="productShare()">
                                <img src="assets/themes/icons/share.svg" alt="share icon" />
                                {{mls.languageText.community.key153}}
                              </button>
                            </div>
                            <ng-container *ngIf="communityDetail?.flags?.show_join_button === numbers.ZERO">
                              <div *ngIf="(communityDetail?.flags?.is_past_community !== isCreator && (communityDetail?.member_type ===  memberType.ADMIN || communityDetail?.flags?.is_community_creator !== isCreator))"
                                class="float-right ml-2 available-options-container" [id]="'COMMUNITY-DETAIL-EXIT-DROPDOWN-' + communityDetail?.da_id">
                                <div ngbDropdown>
                                  <a class="lnguage-selector cursor-pointer" id="community" ngbDropdownToggle>
                                    <img src="assets/themes/icons/kabab-menu-icon.svg" alt="menu icon" />
                                  </a>

                                  <div ngbDropdownMenu aria-labelledby="community" class="ngb-dropdown-list  pt-3 pb-2">
                                    <div *ngIf="communityDetail?.member_type === memberType.ADMIN"
                                      class="text-left pl-0 w-100 pb-2 cursor-pointer list-hover px-3"
                                      (click)="edit()">
                                      {{translations.key2}}
                                    </div>
                                    <div *ngIf="communityDetail.flags.is_community_creator !== isCreator"
                                      class="text-left pl-0 w-100 pb-2 cursor-pointer list-hover px-3"
                                      (click)="exitCommunity()">
                                      {{translations.key11}}
                                    </div>
                                    <div
                                      *ngIf="activateAccess && checkAccessLevel() && communityDetail?.flags?.is_active === isCommunityActive && !showDeactivateOptionNudge &&
                                      (communityDetail?.member_type === memberType.ADMIN || communityDetail.flags.is_community_creator === isCreator)"
                                      class="text-left pl-0 w-100 pr-0 pb-2 cursor-pointer list-hover px-3"
                                      (click)="showDeactivateOption()">
                                      {{mls.languageText.community.key85}}
                                      <svg _ngcontent-gqf-c489="" id="Layer_1" data-name="Layer 1" width="15px" viewBox="0 0 25 25" class="position-absolute" style="right: 100px;top: 53px;">
                                        <defs _ngcontent-gqf-c489="">
                                          <style _ngcontent-gqf-c489=""> .cls-1 { fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.5px; }
                                        </style></defs>
                                        <polyline _ngcontent-gqf-c489="" points="9.82 21 18.32 12.5 9.82 4" class="cls-1"></polyline>
                                      </svg>
                                    </div>
                                    <div *ngIf="activateAccess && checkAccessLevel()  && communityDetail?.flags?.is_active === isCommunityActive && showDeactivateOptionNudge"
                                      class="text-left pl-0 w-100 pr-0 text-danger pb-2 cursor-pointer list-hover px-3"
                                      (click)="inactivateCommunity()">
                                      {{mls.languageText.community.key75}}
                                    </div>
                                    <div
                                      *ngIf="activateAccess && checkAccessLevel() && communityDetail?.flags?.is_active !== isCommunityActive &&  (communityDetail?.member_type === adminMemberType || communityDetail.flags.is_community_creator === isCreator)"
                                      class="text-left pl-0 w-100 pr-0 pb-2 cursor-pointer list-hover px-3"
                                      (click)="ativateCommunity()">
                                      {{mls.languageText.community.key76}}
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
        <div class="d-lg-none">
          <div class="channel-content-container bg-white p-3 mt-3 mb-2 container-shadow"
            *ngIf="communityDetail?.description !='' || communityDetail?.specialties?.length">
            <ng-container *ngIf="communityDetail?.description !=''">
              <p class="heading-4 pb-3">{{translations.key7}}</p>
              <p class="pb-3">
                <app-content-card
                  [cmt]="communityDetail?.description"
                  [showChar]="numbers.FIVE_HUNDRED"
                  [isActionBlock]="false"
                  [defaultline]="numbers.FOUR">
                </app-content-card>
              </p>
            </ng-container>
            <div class="mt-2 d-inline-block w-100" *ngIf="communityDetail?.specialties?.length">
              <span
                class="cursor-pointer secondary-paragraph pr-2 d-inline-block"
                *ngFor="let speciality of communityDetail?.specialties">
                <span (click)="getFeedTagDetails(speciality)"
                  class="color-grey-500"
                  >{{specialCharacter?.HASH}} {{speciality?.speciality_name}}
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="hz-tabs">
          <ul class="tab-items border-bottom mb-3">
            <li>
              <label id="userInfo"
                class="p-2 border-3 cursor-pointer"
                [ngClass]="{'active' : tabSuccess === communityDetailActionTab.POSTS}"
                (click)="selectedTab('posts', true);getPost();">{{translations.key8}}
                  <img *ngIf="communityDetail?.flags?.pulsating?.post === numbers.ONE"
                    class="pulse-icon"
                    src="assets/images/icons/Pulsating-icon.gif"
                    alt="pulsating-icon" />
              </label>
            </li>
            <li>
              <label *ngIf="communityDetail?.flags?.is_active === numbers.ONE && joiningRequestsData?.length"
                id="userInfo"
                class="p-2 border-3 cursor-pointer mb-2"
                [ngClass]="{'active' : tabSuccess === communityDetailActionTab.JOIN_REQUESTS}"
                (click)="selectedTab(communityDetailPageTabFilterText.JOIN_REQUESTS)">{{translations.key18}}
                <img *ngIf="communityDetail?.flags?.pulsating?.pending_member === numbers.ONE"
                  class="pulse-icon"
                  src="assets/images/icons/Pulsating-icon.gif"
                  alt="pulsating-icon">
              </label>
            </li>
            <li>
              <label *ngIf="communityDetail.flags.is_past_community !== isPast"
                class="p-2 border-3 cursor-pointer mb-2"
                [ngClass]="{'active' :tabSuccess === communityDetailActionTab.MEMBERS}"
                (click)="selectedTab('members', true)">{{translations.key9}}
              </label>
            </li>
          </ul>
        </div>
        <ng-container *ngIf="tabSuccess == communityDetailActionTab.POSTS">
          <app-community-posts-filter
              *ngIf="(!isJoinActionEnabled && !isRequestJoinActionEnabled) || pastMember===numbers.ONE && (isPosted > numbers.ZERO)"
              [postDataLoader]="postDataLoader"
              [postedByFilterData]="postedByFilterData"
              [topicList]="topicList"
              [postDataByFilter]="postDataByFilter"
              (changePostFilter)="getPostsByFilter($event)"
              [postOffSet]="postedByFilterOffset"
              (emitReloadFeed)="reloadFeed($event)"
              [isCommunityAdmin]="communityDetail.member_type === memberType.ADMIN">
          </app-community-posts-filter>
          <ng-container *ngIf="(isJoinActionEnabled || isRequestJoinActionEnabled) && ( (postDataLoaded === numbers.ONE && isPosted === numbers.ZERO) || pastMember===numbers.ZERO ) ">
            <ng-container *ngTemplateOutlet="joinCommunityTemplate"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="tabSuccess === communityDetailActionTab.JOIN_REQUESTS">
          <app-community-join-requests
              *ngIf="communityDetail?.flags?.is_active === numbers.ONE && !isJoinActionEnabled && !isRequestJoinActionEnabled"
              [joiningRequestsData]="joiningRequestsData"
              [communityId]="communityId"
              (reloadJoinRequetApi)="getCommunityMembersJoinRequest($event)"
              [joinRequestOffSet]="joinRequestOffSet"
              [loaderState] ="joinRequestAPILoader"
              [callingFrom]="callingFrom"
              [communityDetailId]="communityDetailId">
          </app-community-join-requests>
          <ng-container *ngIf="isJoinActionEnabled || isRequestJoinActionEnabled">
            <ng-container *ngTemplateOutlet="joinCommunity"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="tabSuccess == communityDetailActionTab.MEMBERS">
          <app-community-member-filter
            *ngIf="!isJoinActionEnabled && !isRequestJoinActionEnabled"
            [membersFilterData]="membersFilterData"
            [memberCountData]="communityDetail?.members">
          </app-community-member-filter>
          <ng-container *ngIf="isJoinActionEnabled || isRequestJoinActionEnabled">
            <ng-container *ngTemplateOutlet="joinCommunityTemplate"></ng-container>
          </ng-container>
        </ng-container>
        <div class="text-center">
        </div>
      </div>
      <div class="col-md-4 d-none d-lg-block">
        <div class="channel-content-container bg-white p-3 container-shadow"
          *ngIf="communityDetail?.description !='' || communityDetail?.specialties?.length" [id]="'COMMUNITY-OVERVIEW-' + communityDetail?.da_id">
          <ng-container *ngIf="communityDetail?.description !=''">
            <p class="heading-4 pb-3">{{translations.key7}}</p>
            <p class="pb-3 paragraph">
              <app-content-card
                [cmt]="communityDetail?.description"
                [showChar]="numbers.FIVE_HUNDRED"
                [isActionBlock]="false"
                [defaultline]="numbers.FOUR">
              </app-content-card>
            </p>
          </ng-container>
          <div class="mt-2 d-inline-block w-100" *ngIf="communityDetail?.specialties?.length">
            <span
              class="cursor-pointer secondary-paragraph pr-2 d-inline-block"
              *ngFor="let speciality of communityDetail?.specialties">
              <span (click)="getFeedTagDetails(speciality)"
                class="color-grey-500"
                >{{specialCharacter?.HASH}} {{speciality?.speciality_name}}
              </span>
            </span>
          </div>
        </div>
      </div>
  </div>

  <ng-template #joinCommunityTemplate>
    <div class="bg-white mb-2 clearfix join-community-message">
      <div class="banner mb-4">
        <img src="assets/images/join-public-community.svg"
          alt="Join Public Community" />
      </div>
      <div class="paragraph-bold mb-4">
        {{communityDetail?.flags?.is_active !== isCommunityActive? mls.languageText.community.key84 :translationText(false)}}
      </div>
      <div>
        <div class="btn-design medium"
          [class]="this.withdrawRequest || this.communityDetail?.request?.response === numbers.TWO ? 'filled' : (communityDetail?.flags?.is_active !== isCommunityActive? 'outline-disabled disabled' :'filled')"
          (click)="joinCommunity()">
          <img src="assets/themes/icons/primary-loader.gif"
              class="cursor-pointer loader"
              *ngIf="loader"
              height="20"
              width="20"
              alt="loader"/>
             <span *ngIf="!loader">{{translationText(true)}}</span>
        </div>
      </div>
    </div>
  </ng-template>
  <div *ngIf="!finished" class='text-center'>
    <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post">
  </div>
  <div *ngIf="errorMessage !== ''" class='bg-white text-center text-danger p-3 my-2'>
    <p>{{errorMessage}}</p>
  </div>


  <div *ngIf="showExitModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
         <h4 class="p-3 heading-3"> {{translations.key12}}</h4>
         <p class="px-3 pb-4 paragraph"><span class="color-grey-700">{{translations.key13}}</span></p>
          <div class="row">
            <div class="col-6">
              <button type="button" class="w-100 btn-design outline medium" (click)="exitCommunityConfirm()"> {{translations.key11}}</button>
            </div>
            <div class="col-6">
              <button type="button" class="w-100 btn-design filled medium" data-dismiss="modal" (click)="onHidden()"> {{translations.key14}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="showInactivateModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
         <h4 class="p-3 heading-4">{{mls.languageText.community.key77}}</h4>
         <p class="pb-4 paragraph"> {{mls.languageText.community.key78}}</p>
          <div class="row">
            <div class="col-6 pr-2">
              <button type="button"
                class="w-100 btn-design outline medium"
                (click)="inactivateCommunityYes()">{{mls.languageText.community.key79}}
              </button>
            </div>
            <div class="col-6 pl-2">
              <button type="button"
                class="w-100 btn-design medium filled"
                data-dismiss="modal"
                (click)="onHidden()">{{mls.languageText.community.key80}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showInactivateConfirmModal" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
    (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
         <h4 class="p-3"></h4>
         <p class="p-3 paragraph"> {{mls.languageText.community.key81}}</p>
         <h4 class="p-3"></h4>
          <div class="row">
            <div class="col-6">
              <button type="button"
                class="w-100 btn-design medium outline"
                (click)="inactivateCommunityConfirm()"
                >{{mls.languageText.community.key82}}
              </button>
            </div>
            <div class="col-6">
              <button type="button"
                class="w-100 btn-design medium filled"
                data-dismiss="modal"
                (click)="onHidden()">{{mls.languageText.community.key83}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-confirm-modal
    [isWithdrawRequestConfirmModalShown]="confirmationModal"
    [confirmationModalContent]="confirmationText"
    [getListItem]="communityDetail"
    (resetConfirmModal)="resetConfirmModal()"
    (emitAllowAction)="allowAction($event)">
  </app-confirm-modal>
